<script setup lang="ts">
    const props = withDefaults(defineProps<{ value: string; location?: string }>(), {
        location: 'bottom',
    });
    const copy = () => {
        navigator.clipboard.writeText(props.value);
        useToasteoSuccess('actions.clipboard_copied');
    };
</script>

<template>
    <button
        :data-tooltip="$t('actions.clipboard_copy')"
        :data-tooltip-location="location"
        @click="copy"
    >
        <slot>{{ value }}</slot>
    </button>
</template>
